module.exports = __webpack_public_path__ + "static/media/search.14715489.svg";